import { mdsColorsValue } from "@/design-system/foundations/colors";

export const mdsBorderRadiusValue = {
  // DEPRECATED BORDER RADIUS
  mediumPlus: 6,
  mediumLarge: 8,
  mediumLargePlus: 12,
  xLarge: 24,
  maximum: 100,

  // UPDATED BORDER RADIUS
  none: "0px",
  small: "4px",
  medium: "8px",
  large: "16px",
  xlarge: "28px",
  max: "100px",
} as const;

export const mdsTransitionsValue = {
  background: "background 0.08s ease",
} as const;

export const mdsBordersValue = {
  default: `1px solid ${mdsColorsValue.grey.x100}`,
} as const;

export const mdsShadowsValue = {
  surface: "0 4px 6px 0 rgba(55, 55, 55, 0.10)",
};

export type MDSBorderRadius = typeof mdsBorderRadiusValue;
export type MDSTransitions = typeof mdsTransitionsValue;
export type MDSBorders = typeof mdsBordersValue;
export type MDSShadows = typeof mdsShadowsValue;

// Function versions for backward compatibility
export const mdsBorderRadius = () => mdsBorderRadiusValue;
export const mdsTransitions = () => mdsTransitionsValue;
export const mdsBorders = () => mdsBordersValue;
export const mdsShadows = () => mdsShadowsValue;
